import React, { useEffect, useRef, useState } from "react";
import LogoQR from "assets/icons/QR.png";
import classes from "./Login.module.scss";
import QRCode from "react-qr-code";
import CircularIndeterminate from "components/utils/spinner/Spinner";
import { LinearProgress } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { FormikSelectInput } from "components/Filters/FormikInputs";
// Services
import { loginQREvent, loginQRGet, loginQRMerchant } from "services/services-mia/login";
import { SFServicioGet } from "services/services-mia/SFServicioGet";
import { usuarioMinimosGet } from "services/services-mia";
import { merchantLogoGet } from "services/services-mia/merchant";

import { checkAuth } from "services/checkAuth";
// Recoil
import {
    userCredentials,
    snackbarData,
    userInfo,
    services,
} from "recoilState/GlobalState";
import { useSetRecoilState } from "recoil";
import { LogoRioNegro, LogoSantaFe, RNQR } from "assets/icons";
import { Routes } from "consts/Routes-App";
import { useLocation, useNavigate } from "react-router-dom";
import { SFUsuarioHotelGet } from "services/services-mia/SFUsuarioHotelGet";

export default function Login() {
    const setCredentials = useSetRecoilState(userCredentials);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const setInfo = useSetRecoilState(userInfo);
    const setServices = useSetRecoilState(services);
    const navigate = useNavigate();
    const location = useLocation();

    const [UUID, setUUID] = useState();
    const [loading, setLoading] = useState(false);
    const [expirado, setExpirado] = useState(false);
    const [coord, setCoord] = useState({});
    const [progress, setProgress] = useState(0);
    const intentos = useRef(0);
    const from = location.state?.from?.pathname + location.state?.from?.search || Routes.dashboard.route;

    async function getQR(e) {
        if (e) e.preventDefault();
        setExpirado(false);
        setLoading(true);
        const { result } = await loginQRGet({
            sesionLatitud: coord.lat.toFixed(6),
            sesionLongitud: coord.lng.toFixed(6),
        });
        const data = result[0]
        setProgress(0);

        setUUID(data.codigoQR);
        setLoading(false);
    }

    useEffect(() => {
        if (checkAuth()) {
            navigate(from, { replace: true });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (data) => {
                setCoord({
                    lat: data.coords.latitude,
                    lng: data.coords.longitude,
                });
            },
            (error) =>
                setSnackbarInfo({
                    message: "Error de localización",
                    open: true,
                    severity: "error",
                })
        );
        const timer = setInterval(() => {
            setProgress((oldProgress) =>
                oldProgress + 60 / 580 >= 100
                    ? 100
                    : oldProgress + ((60 / 580) * 100) / 60
            );
        }, (60 / 580) * 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if (coord.lat && coord.lng) getQR();
    }, [coord]);

    useEffect(() => {
        if (UUID) {
            (async function getQREvent() {
                const { result, status } = await loginQREvent({
                    codigoQR: UUID,
                });
                if (status.code === 1) {
                    setLoading(true);
                    const newCredentials = {
                        sessionId: result[0].sessionId,
                        hooliToken: result[0].hooliToken
                    }

                    const servicesResponse = await SFServicioGet(
                        {},
                        newCredentials
                    );
                    if (servicesResponse?.status?.code !== 1 || !servicesResponse?.result?.length) { 
                        setSnackbarInfo({
                            open: true,
                            message: "Login no autorizado",
                            severity: "error",
                        });
                        setTimeout(() => {
                            setSnackbarInfo({
                                open: false,
                                message: "",
                                severity: "error",
                            });
                        }, 5000);
                        setUUID(null);
                        setExpirado(true);
                        setLoading(false);
                        return;
                    }
    
                    setServices(servicesResponse.result);
                                        
                    const hotelsResult = await SFUsuarioHotelGet(newCredentials);
                    console.log(hotelsResult)
                    if (!hotelsResult?.length) {
                        setSnackbarInfo({
                            open: true,
                            message: "Login no autorizado",
                            severity: "error",
                        });
                        setTimeout(() => {
                            setSnackbarInfo({
                                open: false,
                                message: "",
                                severity: "error",
                            });
                        }, 5000);
                        setLoading(false);
                        return;
                    }

                    setCredentials(newCredentials);
                    sessionStorage.setItem("hooliToken", newCredentials.hooliToken);
                    sessionStorage.setItem("sessionId", newCredentials.sessionId);
                    
                    const userData = await usuarioMinimosGet(newCredentials);
                    setInfo(userData);
                    
                    setLoading(false);

                    navigate(from, { replace: true });
                    return;
                }
                
                intentos.current++;
                setUUID(null);
                if (intentos.current > 2) {
                    setExpirado(true);
                } else {
                    getQR();
                }
                
            })();
        }
    }, [UUID]);

    return (
        <main className={classes.root}>
            <div className={classes.logoContainer}>
                <img src={LogoSantaFe} alt="logo-rn" />
            </div>
            <div className={classes.login}>
                <div className={classes.container}>
                    <div className={classes.qrContainer}>
                        {expirado ? (
                            <>
                                <h4>Ups!</h4>
                                <p>
                                    El código caducó, generá un{" "}
                                    <span>nuevo QR</span> para poder ingresar.
                                </p>
                                <img src={RNQR} alt="Celular" />
                                <button
                                    className={classes.button}
                                    onClick={getQR}
                                >
                                    Generar QR
                                </button>
                            </>
                        ) : (
                            <>
                                {(UUID && !loading) ? ( 
                                    <>
                                        <h4>Hola!</h4>
                                        <p>
                                            Para poder ingresar, escanea el código QR desde la App de Santa Fe
                                        </p>
                                        <QRCode value={UUID} />
                                        <LinearProgress
                                            variant="determinate"
                                            value={progress}
                                            style={{
                                                width: "100%",
                                                marginTop: "16px",
                                            }}
                                            color="secondary"
                                        />
                                    </>
                                ) : (
                                    <CircularIndeterminate />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </main>
    );
}
